var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-16 max-w-5xl mx-auto"},[_c('div',[_c('InsightsChart',{attrs:{"daily-reports":_vm.facebookCampaign.dailyReports},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('LineChart',{attrs:{"chart-data":props.chartData,"options":props.options}})]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }